import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as hostingCertificatesActions from '../actions/hosting-certificates.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {HostingService} from "../../websites/website/hosting/hosting.service";
import {LoadCertificates} from "../actions";

@Injectable()
export class HostingCertificatesEffects {

  loadCertificates = createEffect(() => this._actions$.pipe(
    ofType(hostingCertificatesActions.LOAD_CERTIFICATES),
    mergeMap((action: LoadCertificates) => {
      return this._hostingService.getCertificates(action.payload)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new hostingCertificatesActions.LoadCertificatesSuccess({
                websiteId: action.payload,
                entities: response.data
              });
            }
            return new hostingCertificatesActions.LoadCertificatesFail(response.message);
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _hostingService: HostingService
  ) {
  }

}
